/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { ShippingThreshold } from './ShippingThreshold';
import { TileHead } from '../TileHead';
import { TileFooter } from '../TileFooter';
import { FULFILLMENT_METHODS } from '../../../constants';
import { IDS } from '../../../../automationTestIds';

export const ApplianceShipping = ({
  formattedEarliestDelivery,
  hasFreeShipping
}) => {
  return (
    <div>
      <TileHead
        title="Delivery"
        automationId={IDS.LABEL.sthLabel}
      />
      <div data-testid="ffm-details-row" className="sui-pt-2">
        {formattedEarliestDelivery ? (
          <>
            <Typography variant="body-base">
              <div
                className="sui-min-h-[24px] sui-pb-1"
                data-automation-id={IDS.ETA.sthETA}
              >
                Earliest delivery
              </div>
            </Typography>
            <Typography variant="body-base" weight="bold">
              <div
                data-testid="fulfillment-qty-row"
                className="sui-min-h-[24px]"
                data-automation-id={IDS.QTY.sthQty}
              >
                {formattedEarliestDelivery}
              </div>
            </Typography>

          </>
        )
          : (
            <div className="sui-pb-1 sui-min-h-[48px]">
            &nbsp;
            </div>
          )}
      </div>
      <TileFooter className="sui-font-bold" isDelivery>
        <ShippingThreshold
          type={FULFILLMENT_METHODS.APPLIANCE}
          hasFreeShipping={hasFreeShipping}
        />
      </TileFooter>
    </div>

  );
};

ApplianceShipping.propTypes = {
  formattedEarliestDelivery: PropTypes.string,
  hasFreeShipping: PropTypes.bool
};

ApplianceShipping.defaultProps = {
  formattedEarliestDelivery: null,
  hasFreeShipping: false
};
